module.exports = __webpack_public_path__ + "static/media/business-icon.6b5a0270.svg";